module.exports = __webpack_public_path__ + "img/_blog2.4eb33247.jpg";